// extracted by mini-css-extract-plugin
module.exports = {"card":"WorkflowCard_card_KfVUz","title":"WorkflowCard_title_pl_HO"};